module.exports = __webpack_public_path__ + "img/plusfl_4.64ec6749.png";